export default import.meta.ROLLDOWN_FILE_URL_XDcYaTlHe6QmjXZTJZz$Wg